import { render, staticRenderFns } from "./BillingInvoicesAdmin.vue?vue&type=template&id=64807241"
import script from "./BillingInvoicesAdmin.vue?vue&type=script&lang=js"
export * from "./BillingInvoicesAdmin.vue?vue&type=script&lang=js"
import style0 from "./BillingInvoicesAdmin.vue?vue&type=style&index=0&id=64807241&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports